import { useEffect } from 'react';

var testVariabile = 0;
function Debug() {
    // const spinner = useContext(SpinnerContext)

    testVariabile++;
    // const showSpinnerMain = () => {
    //     spinner.setShowSpinner(true)
    // }
    // const hideSpinnerMain = () => {
    //     spinner.setShowSpinner(false)
    // }

    useEffect(() => {
        console.log("component mount")
        return () => {

        }
    }, [])

    // const testTostifySuccess = () => {
    //     toast.success('✔️ Wow so easy!');
    // }
    // const testTostifyFail = () => {
    //     toast.error('🛑 Wow so easy!');
    // }
    // const testTostifyInfo = () => {
    //     toast.info('ℹ️ Wow so easy!');
    // }
    // const testTostifyWarn = () => {
    //     toast.warn('⚠️ Wow so easy!');
    // }
    return (
        <div>
            <p>test variabile: {testVariabile}</p>
            <div>

                {/*<div>*/}
                {/*    <Button onClick={showSpinnerMain}>Apri spinner global</Button>*/}
                {/*    <Button onClick={hideSpinnerMain}>Close spinner global</Button>*/}
                {/*</div>*/}

                {/*<div>*/}
                {/*    <Button onClick={testTostifySuccess}>test Tostify success</Button>*/}
                {/*    <Button onClick={testTostifyFail}>test Tostify fail</Button>*/}
                {/*    <Button onClick={testTostifyInfo}>test Tostify info</Button>*/}
                {/*    <Button onClick={testTostifyWarn}>test Tostify warn</Button>*/}
                {/*</div>*/}
                {/*<div>*/}
                {/*    <BButton><RiHomeHeartFill />Bbutton default</BButton>*/}
                {/*    <BButton variante="arancio"><RiFilter2Fill />Filter</BButton>*/}
                {/*    <BButton><RiFileAddFill />Aggiungi</BButton>*/}
                {/*</div>*/}

            </div>
        </div>
    )
}


export default Debug
